import React from 'react';

import ModalPageContentRole from './ModalPageContent/ModalPageContentRole';

export default function CheckOutRole() {
  return <ModalPageContentRole />;
}
